import { getField } from 'vuex-map-fields';

const getters = {
  getField,
};

export default getters;



// WEBPACK FOOTER //
// ./src/store/modules/settings/getters.js